import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { FaCheck } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";

const NewsPreferences = () => {

  const [iState,setUpdate] = useState({});

  const {userDetails} = useSelector((state) => state.UserManagement);

  useEffect(()=>{
    if(userDetails && Object.keys(userDetails).length > 0){
      setUpdate(userDetails);
    }
  },[userDetails])


  return (
    <>
     <div className="row">
  <div className="col-sm-7">
    <div className="Small-Wrapper">
      <div className="News-References">
        <h3>
          No input was provided for the following topics.
          <br />
          Please mark your selection.
        </h3>
        <div className="TableList">
          <table>
            <tbody>
              {userDetails && userDetails?.preferences && userDetails?.preferences?.newsPreference?.map((item,index)=>{
              return(
              <tr>
                <td className="icon">{
                  <img
                    src={item?.catImage}
                    alt="icon"
                    style={{height:"30px",width:"30px",borderRadius:"100%"}}
                  />
                  }</td>
                <td>{item?.catName}</td>
                <td>
                 
                  <button
                    className="thumb up"
                    onclick="markSelection('Politics', 'up')"
                  >
                  {item?.isSelected ? <FaCheck />:<IoMdClose style={{color:"red",fontSize:"22px"}} />}
                  </button>
                </td>
              </tr>
              )
              })
}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
 
    </>
  )
}

export default NewsPreferences
